module.exports = __webpack_public_path__ + "static/media/cq_tel_fisso b.856870e2.svg";